<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Escolha o médico do corpo clínico."
    [visible]="showDialog()"
    (visibleChange)="showDialog.set($event)"
    [style]="{ width: 'min(94vw, 720px)' }"
    [appendTo]="'body'"
    [header]="titulo()"
    (onShow)="aoAbrir()"
>
    <div class="mb-3">
        <input pInputText class="w-full" placeholder="Filtrar por nome ou CRM" [ngModel]="filtro()" (ngModelChange)="filtro.set($event)" />
    </div>

    <p-table
        [value]="medicosFiltrados()"
        selectionMode="single"
        [selection]="selecionado()"
        (selectionChange)="selecionado.set($event)"
        dataKey="idMedico"
        [scrollable]="true"
        scrollHeight="380px"
        stripedRows
        [loading]="carregando()"
        [tableStyle]="{ 'min-width': '40rem' }"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>UF</th>
                <th>CRM</th>
                <th>Nome</th>
                <th>Situação</th>
                <th>Alertas</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr [pSelectableRow]="item" [pSelectableRowDisabled]="!item.selecionavel" [class.opacity-60]="!item.selecionavel" [pTooltip]="item.selecionavel ? '' : item.motivosBloqueio.join(' ')" tooltipPosition="top" (click)="selecionarLinha(item)">
                <td>{{ item.ufMedico }}</td>
                <td>{{ item.crm || '-' }}</td>
                <td>{{ item.nome || '-' }}</td>
                <td>{{ item.situacao || '-' }}</td>
                <td>
                    @if (item.selecionavel) {
                        <span class="text-green-600">Disponível</span>
                    } @else {
                        <span class="texto-aviso">{{ item.motivosBloqueio.join(' ') }}</span>
                    }
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" class="text-center p-5"><i>Nenhum médico no corpo clínico ativo.</i></td>
            </tr>
        </ng-template>
    </p-table>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" (onClick)="fechar()" />
        <p-button label="Selecionar" icon="pi pi-check" [disabled]="!selecionado()" (onClick)="confirmar()" />
    </ng-template>
</p-dialog>
